<div class="container-fluid">
  <div class="row no-gutters">
    <div class="col-12 cols">
      <!-- Left Section -->
      <div class="col-md-6 col-sm-12 left-section">
        <div class="logo-container">
          <!-- <img
          src="../../assets/images/logo.svg"
          alt="logo-main"
          class="img-fluid"
        /> -->
          <ul class="d-flex" style="list-style: none">
            <li>
              <img
                src="../../assets/images/grammarin-logo/grammarin-logo.svg"
                [routerLink]="['/']"
                alt="logo-main"
                class="img-fluid"
                class="logo"
              />
            </li>
          </ul>
        </div>
        <div class="login-form">
          <h3 class="mb-1" style="font-size: 28px; font-weight: 600">
            Create an account
          </h3>
          <p
            class="p"
            [ngStyle]="{
              'margin-bottom': fieldIf ? '10px' : '20px'
            }"
            style="font-weight: 500; font-size: 16px; line-height: 24px"
          >
            Enter your details below to create you account and get started.
          </p>
          <span
            class="alert alert-danger mb-2"
            id="dangerAlerts"
            *ngIf="fieldIf"
            [ngStyle]="{ color: color }"
            >{{ dangerAlerts }}</span
          >

          <p
            *ngIf="emailerror"
            class="checkmail alert"
            id="dangerAlerts2"
            [ngStyle]="{ color: color1 }"
          >
            {{ dangerAlerts2 }}
          </p>
          <form>
            <div class="form-group">
              <label for="Your Name" class="" style="font-weight: 500"
                >Your Name</label
              >

              <input
                id="firstname"
                type="text"
                class="form-control"
                formControlName="firstname"
                maxlength="2"
                maxlength="20"
                name="firstname"
                value=""
                placeholder="Your Name"
                onfocus="this.placeholder=''"
                onblur="this.placeholder='Your Name'"
                (focus)="onFocus()"
                required
              />
            </div>
            <div class="form-group">
              <label for="email" style="font-weight: 500">Your Email</label>
              <input
                id="email"
                type="email"
                class="form-control"
                name="email"
                formControlName="email"
                value=""
                placeholder="Example@email.com"
                onfocus="this.placeholder=''"
                onblur="this.placeholder='Example@email.com'"
                (focus)="onFocus()"
                required
              />
            </div>
            <div class="form-group">
              <label for="password" style="font-weight: 500">Password</label>
              <input
                id="pass_log_id5"
                type="password"
                [type]="passwordFieldType"
                class="form-control"
                value=""
                name="password"
                formControlName="password"
                placeholder="At least 8 characters"
                onfocus="this.placeholder=''"
                onblur="this.placeholder='At least 8 characters'"
                (focus)="onFocus()"
                required
              />
            </div>
            <span
              style="
                color: #000000;
                float: right;
                margin-bottom: -30px;
                padding-left: 20px;
                margin-top: -45px;
                margin-right: 20px;
                cursor: pointer;
              "
            >
              <i
                class="eye-icon"
                (click)="togglePasswordVisibility()"
                [ngClass]="{
                  'fa fa-fw fa-eye': passwordFieldType === 'password',
                  'fas fa-eye-slash': passwordFieldType === 'text'
                }"
              ></i>
            </span>
            <!-- <div class="form-group text-right">
            <a routerLink="/forgot-password" class="text-dark" (click)="navigateTosiforgot()"  style="cursor: pointer;">Forgot Password?</a>
          </div> -->

            <div
              id="recaptcha-container"
              data-size="compact"
              data-theme="light"
              style="display: flex; justify-content: center; margin-top: 7px"
            ></div>
            <p class="links mt-2">
              Sign up with Google to get started. By continuing, you agree to
              our
              <a href="https://www.grammarin.com/terms-conditions" class="aTag">
                Terms & Conditions</a
              >
              and
              <a href="https://www.grammarin.com/privacy-policy" class="aTag"
                >Privacy Policy</a
              >.
            </p>

            <div class="form-group">
              <button
                type="submit"
                class="btn btn-dark btn-block mt-0"
                style="width: 388px; height: 52px !important"
                (click)="handleButtonClick($event)"
              >
                Sign up
              </button>
            </div>
          </form>
          <div class="or-separator mt-0 mb-3"><span>Or</span></div>
          <div class="social-buttons">
            <button class="btn btn-block mb-0" (click)="googleLogin()">
              <img
                src="../../assets/images/signin-signup/google.svg"
                alt="Google"
              /><span>Sign in with Google</span>
            </button>
            <!-- <button class="btn btn-block">
            <img
              src="../../assets/images/signin-signup/fb.svg"
              alt="Facebook"
            />Sign in with Facebook
          </button> -->
          </div>
          <p class="text-center mt-3">
            Have an account?
            <a
              [routerLink]="['/signin']"
              style="color: #08ba9c; cursor: pointer"
              >Login</a
            >
          </p>
          <!-- (click)="navigateTosignin()" -->
        </div>
      </div>
      <!-- Right Section -->
      <div class="col-lg-6 col-md-6 col-sm-12 right-section">
        <div class="marginSection">
          <h4>Sign Up</h4>
          <p>
            To keep connected with us please signup with your personal
            information <br />
            by email address and password
          </p>
          <img
            src="../../assets/images/editorimages/editor-new-logo.png"
            alt="Illustration"
            class="IllustrationImage img-fluid mb-4"
          />
        </div>
      </div>
    </div>
  </div>
</div>
